import { render, staticRenderFns } from "./CloseViewLinkEl.vue?vue&type=template&id=1b8229d4&scoped=true&"
import script from "./CloseViewLinkEl.vue?vue&type=script&lang=ts&"
export * from "./CloseViewLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./CloseViewLinkEl.vue?vue&type=style&index=0&id=1b8229d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8229d4",
  null
  
)

export default component.exports